import { useContext, useMemo, useState } from "react"
import { AuthContext } from "../../../../context/auth"
import { canAccess } from "../../../../router/permissions"
import { actionKeys, pagesKeys } from "../../../../utils"
import { useStatisticInputs } from "../constants/inputs"

export const useStatisticReportModalController = () => {
    const statisticInputs = useStatisticInputs()
    const { state } = useContext(AuthContext)
    const pageId = pagesKeys.main
    const [open, setOpen] = useState(false)
    const [data, setData] = useState({ selected: [] })
    const [inputs, setInput] = useState(statisticInputs)
    const [loading, setLoading] = useState(false)
    const access = useMemo(() => canAccess(actionKeys.statisticReport, pageId, state), [pageId, state])

    const handleOptions = ({ name, list = [] }) => {
        setInput(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                options: list
            }
        }))
    }

    const handleSelect = ({ id }) => {
        setData(prev => {
            let selectList = [...prev.selected]
            if (!selectList.includes(id)) {
                selectList.push(id)
            } else {
                selectList = selectList.filter(item => item !== id)
            }

            return {
                ...prev,
                selected: selectList
            }
        })
    }

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        setData({ selected: [] })
        setLoading(false)
    }

    const handleChange = ({ target }) => {
        const { name, value } = target
        setData(prev => ({ ...prev, [name]: value }))
    }

    const disabledSave = useMemo(() => !data?.selected?.length || !data?.start, [data])

    return {
        inputs,
        open,
        data,
        access,
        disabled: disabledSave,
        loading,
        handleSelect,
        setLoading,
        handleOptions,
        handleChange,
        handleOpen,
        handleClose
    }
}